<template>
  <v-container fluid>
    <customer-report-title :title="options.title" class="mb-2" />
    <customer-report-sub-category :tabs="options.tabs" @select-tab="selectTab" />
    <customer-report-filter
      :organizations="options.organizations"
      @load-report="loadReport($event)"
      @export-table="exportTableToXLSX($event)"
    />
    <customer-report-kpi-bar />
    <customer-report-table :headers="options.headers" :items="options.data" />
    <customer-report-alert />
  </v-container>
</template>

<script>
import { Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { json2xlsx } from "@/util/helpers";

export default Vue.extend({
  name: "CustomerReportTemplate",
  components: {
    CustomerReportTitle: () => import("@/components/report/customerreport/CustomerReportTitle.vue"),
    CustomerReportChart: () => import("@/components/report/customerreport/CustomerReportChart.vue"),
    CustomerReportSubCategory: () =>
      import("@/components/report/customerreport/CustomerReportSubCategory.vue"),
    CustomerReportFilter: () => import("@/components/report/customerreport/CustomerReportFilter.vue"),
    CustomerReportKpiBar: () => import("@/components/report/customerreport/CustomerReportKPIBar.vue"),
    CustomerReportTable: () => import("@/components/report/customerreport/CustomerReportTable.vue"),
    CustomerReportAlert: () => import("@/components/report/customerreport/CustomerReportAlert.vue")
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    },
    series: {
      type: Array,
      required: true
    },
    selectTab: {
      type: Function,
      required: true
    },
    loadReport: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapState({ errorMessage: state => state.report.errorMessages.export })
  },
  data() {
    return {};
  },
  methods: {
    exportTableToXLSX(currentTab) {
      this.options.data.length > 0
        ? json2xlsx({
            data: this.options.data,
            header: [this.options.headers.map(header => header.text)],
            sheetName: "Отчет",
            fileName:
              "ИСУНГ - " + this.options.title + " - " + currentTab.name + ".xlsx"
          })
        : console.log(this.errorMessage);
    }
  },
  mounted() {}
});
</script>
